const strings = {
  en: {
    heroLabel: 'Mobile App',
    heroTitle: 'Your Sales Team,\nAlways Connected',
    heroSubtitle:
      'Download Sapot AI and empower your field sales team with AI-powered meeting notes, real-time coaching, and instant follow-ups — right from their pocket.',
    iosLabel: 'Download on the',
    iosStore: 'App Store',
    androidLabel: 'Get it on',
    androidStore: 'Google Play',
    apkLabel: 'Download',
    apkStore: 'APK File',

    featuresTitle: 'Everything you need, on the go',
    featuresSubtitle: 'The full power of Sapot AI, now in your pocket.',
    features: [
      {
        icon: '🎙️',
        title: 'AI Meeting Notes',
        desc: 'Automatically transcribe and summarize every sales call, hands-free.',
      },
      {
        icon: '🏆',
        title: 'Real-Time Coaching',
        desc: 'Get instant feedback and performance scores after every field visit.',
      },
      {
        icon: '💬',
        title: 'Instant Follow-ups',
        desc: 'Send personalized WhatsApp follow-ups with a single tap.',
      },
      {
        icon: '📍',
        title: 'GPS Tracking',
        desc: 'Track field visits and verify check-ins without any extra effort.',
      },
    ],

    qrTitle: 'Scan to Redirect',
    qrSubtitle: 'Point your camera at the QR code to get the app.',
    req1: 'iOS 15.1 or later  ·  iPhone & iPad',
    req2: 'Android 7.0 or later',

    ctaTitle: 'Ready to get started?',
    ctaSubtitle: 'Download the app and empower your sales team today.',
  },
  zh: {
    heroLabel: '移动应用',
    heroTitle: '销售团队，\n随时在线',
    heroSubtitle:
      '下载 Sapot AI，让您的外勤销售团队随时随地享受 AI 会议记录、实时辅导与即时跟进——全在掌中。',
    iosLabel: '下载于',
    iosStore: 'App Store',
    androidLabel: '立即获取',
    androidStore: 'Google Play',
    apkLabel: '下载',
    apkStore: 'APK 文件',

    featuresTitle: '随时随地，一切尽在掌握',
    featuresSubtitle: 'Sapot AI 的全部功能，现已登陆移动端。',
    features: [
      {
        icon: '🎙️',
        title: 'AI 会议记录',
        desc: '自动转录并摘要每一次销售拜访，解放双手。',
      },
      {
        icon: '🏆',
        title: '实时辅导',
        desc: '每次拜访后即时获得反馈与绩效评分。',
      },
      {
        icon: '💬',
        title: '即时跟进',
        desc: '一键发送个性化 WhatsApp 跟进消息。',
      },
      {
        icon: '📍',
        title: 'GPS 定位',
        desc: '轻松追踪外勤拜访并自动验证打卡，无需额外操作。',
      },
    ],

    qrTitle: '扫码跳转',
    qrSubtitle: '用手机摄像头扫描二维码获取应用。',
    req1: 'iOS 15.1 及以上  ·  iPhone & iPad',
    req2: 'Android 7.0 及以上',

    ctaTitle: '准备好开始了吗？',
    ctaSubtitle: '立即下载应用，赋能您的销售团队。',
  },
};

export default strings;
